import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import { connect } from "react-redux";
import { State } from "../reducers/reducer";
import { updateSelectedYear } from "../reducers/general";
import Select, { SelectProps } from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    selectRoot: {
      minWidth: "120px",
    },
    selectText: {
      color: `${theme.palette.primary.main} !important`,
    },
    selectPlaceholder: {
      color: `${theme.palette.action.disabled} !important`,
    },
    outline: {
      borderColor: `${theme.palette.primary.main} !important`,
    },
  })
);

interface Props {
  fullWidth?: boolean;
  className?: any;
}

interface StateProps {
  data: any[];
  value: any;
  updateSelectedYear: any;
}

const mapStateToProps = (state: State, ownProps: Props) => ({
  data: state.general.year.yearList,
  value: state.general.year.selectedYear,
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    dispatch,
    updateSelectedYear: (year: number) => dispatch(updateSelectedYear(year)),
  };
};

const YearSelect = ({
  data,
  value,
  updateSelectedYear,
  className,
  ...rest
}: SelectProps & StateProps) => {
  const classes = useStyles();

  return (
    <Select
      {...rest}
      value={value}
      onChange={e => updateSelectedYear(e.target.value)}
      className={clsx(classes.selectRoot, className)}
      classes={{
        select: value ? classes.selectText : classes.selectPlaceholder,
      }}
      input={
        <OutlinedInput
          labelWidth={0}
          classes={{ notchedOutline: classes.outline }}
        />
      }
    >
      {data
        ? data.map((value: any, index: number) => (
            <MenuItem key={"Yearselect" + index} value={value.year}>
              {value.year}
            </MenuItem>
          ))
        : null}
    </Select>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(YearSelect);
